import dlv from 'dlv';
const seoResponseTransform = (seo: any) => {
  if (seo) {
    const metaImage = dlv(
      seo,
      'metaImage.data.attributes.formats.thumbnail.url',
      dlv(seo, 'metaImage.data.attributes.url', ''),
    );
    const metaSocial = (seo.metaSocial || []).map((metaSocial: any) => {
      return {
        ...metaSocial,
        image: dlv(
          metaSocial,
          'image.data.attributes.formats.thumbnail.url',
          dlv(metaSocial, 'image.data.attributes.url', ''),
        ),
      };
    });

    seo.metaImage = metaImage;
    seo.metaSocial = metaSocial;
    return seo;
  }
  return seo;
};

export default seoResponseTransform;
